import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-ssc-houer',
  templateUrl: './ssc-houer.component.html',
  styleUrls: ['./ssc-houer.component.css']
})
export class SscHouerComponent implements OnInit {

  @ViewChild('HouErTrendLine') houer_trend_line_ref: ElementRef;

  @Input()
  public auxs: Array<any>;

  @Input()
  public issue_num: string;

  @Input()
  public trend_data: Array<any>;

  @Input()
  public analysis_data: Array<any>;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.draw_houer_trend_line_handler();
  }

  // 后二走势线
  public draw_houer_trend_line_handler() {
    // 设置canvas高度
    this.houer_trend_line_ref.nativeElement.width = 440;
    this.houer_trend_line_ref.nativeElement.height = this.trend_data.length * 30;

    const houer_cxt: CanvasRenderingContext2D = this.houer_trend_line_ref.nativeElement.getContext('2d');

    let w: number = 440;
    let h: number = this.trend_data.length * 30;
    houer_cxt.fillStyle = 'rgba(255, 255, 255, 0)';
    houer_cxt.clearRect(0, 0, w, Number(this.issue_num) * 30);
    houer_cxt.fillRect(0, 0, w, h);

    for (let i = 3; i < 5; i++) {
      houer_cxt.beginPath();

      for (let j = 0; j < this.trend_data.length - 1; j++) {
        let win_num_1 = Number(this.trend_data[j].lottery[i]);
        let win_num_2 = Number(this.trend_data[j + 1].lottery[i]);

        let cell_w = 22;
        let cell_h = 30;

        let x1: number = (cell_w * 10 * (i - 3)) + Number(win_num_1) * cell_w + cell_w / 2;
        let y1: number = (j * cell_h) + cell_h / 2;

        let x2: number = (cell_w * 10 * (i - 3)) + Number(win_num_2) * cell_w + cell_w / 2;
        let y2: number = ((j + 1) * cell_h) + cell_h / 2;

        houer_cxt.lineWidth = 1;
        houer_cxt.strokeStyle = '#FF5656';

        houer_cxt.moveTo(x1, y1);
        houer_cxt.lineTo(x2, y2);
        houer_cxt.stroke();
      }

      houer_cxt.closePath();
    }
  }

}
